import { render, staticRenderFns } from "./Infraestrutura.vue?vue&type=template&id=20a2fd08&"
import script from "./Infraestrutura.vue?vue&type=script&lang=js&"
export * from "./Infraestrutura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports